import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gramsToKg',
  standalone: true
})
export class GramsToKgPipe implements PipeTransform {
  /**
   * Converts a weight value in grams (g) to kilograms (kg).
   *
   * - Accepts numbers or numeric strings (also tolerates comma as decimal separator).
   * - Returns '-' when the input is empty or not a valid number.
   * - By default formats to 2 fraction digits, and then trims trailing zeros.
   *
   * @param value Weight in grams.
   * @param fractionDigits Number of decimal places to keep (default 2).
   */
  transform(value: number | string | null | undefined, fractionDigits = 2): string {
    // Treat null/undefined/empty-string as "no value".
    if (value === null || value === undefined || value === '') {
      return '-';
    }

    // Normalize string input (e.g. "12,5" -> "12.5") before parsing.
    const normalized = typeof value === 'string' ? value.replace(',', '.') : value;
    const grams = typeof normalized === 'number' ? normalized : Number.parseFloat(normalized);

    // Guard against NaN/Infinity.
    if (!Number.isFinite(grams)) {
      return '-';
    }

    // Keep digits non-negative and integer-like.
    const digits = Number.isFinite(fractionDigits) ? Math.max(0, Math.floor(fractionDigits)) : 2;

    // Core conversion: 1000 g = 1 kg.
    const kg = grams / 1000;
    const fixed = kg.toFixed(digits);

    // Remove trailing zeros (e.g. "1.00" -> "1", "1.50" -> "1.5").
    return fixed.replace(/\.0+$|(?<=\.[0-9]*?)0+$/g, '').replace(/\.$/, '');
  }
}
